import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SelectChangeEvent } from 'primeng/select';
import {
  AgreementPartnerDetailsRequest,
  PartnerDetails
} from '../../../models/agreement-partner-details.model';
import { ProgramTypeDisplayNames } from '../../../models/event-type.model';
import { ExportService } from '../../services/export.service';
import { PartnerWorkshopApi } from '../../services/partner-workshop.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-program-agreement-partner-details',
  templateUrl: './agreement-partner-details.component.html',
  styleUrls: ['./agreement-partner-details.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class AgreementPartnerDetailsComponent implements OnInit {
  agreementPartnerDetailsForm!: FormGroup;
  selectedTab!: number;
  selectedProgramTypes!: number[];
  loading = false;
  selectedProgramType: any;
  maxDate: Date = new Date();
  datePipe = new DatePipe('en-US');
  calanderYearRange = '';
  programtypes: ProgramTypeDisplayNames[] = [];
  errorMessage =
    "No program agreement(s) have been created between 'Selected Date' and 'Current Date'.";
  isEmptyPartnerList = false;

  constructor(
    private partnerworkshopservice: PartnerWorkshopApi,
    private formBuilder: FormBuilder,
    private exportService: ExportService
  ) {}

  onFromGroup(): void {
    this.calanderYearRange =
      (new Date().getFullYear() - 10).toString() +
      ':' +
      new Date().getFullYear();
    this.agreementPartnerDetailsForm = this.formBuilder.group({
      partnerWorkshopType: [''],
      fromDate: ['']
    });
  }

  ngOnInit(): void {
    this.selectedTab = 0;
    this.onFromGroup();
    this.partnerworkshopservice.getProgramTypeDisplayNames().subscribe(data => {
      this.programtypes = data;
    });
    this.loading = false;
    this.agreementPartnerDetailsForm.controls[
      'fromDate'
    ].valueChanges.subscribe(() => {
      this.isEmptyPartnerList = false;
    });
  }

  onProgramTypeChange(event: SelectChangeEvent): void {
    this.isEmptyPartnerList = false;
    this.selectedProgramTypes = [(event as any).value[0]];
  }

  downloadPartnerDetails(): void {
    this.loading = true;

    const partnerDetailsRequest: AgreementPartnerDetailsRequest = {
      startDate: this.agreementPartnerDetailsForm.controls['fromDate'].value,
      programTypeIds: this.selectedProgramTypes
    };

    this.partnerworkshopservice
      .getAgreedPartnerDetails(partnerDetailsRequest)
      .subscribe(partnerList => {
        if (
          partnerList === null ||
          partnerList.length === null ||
          partnerList.length === 0
        ) {
          this.isEmptyPartnerList = true;
          this.loading = false;
        } else {
          this.exportToCSV(partnerList);
        }
      });
  }

  exportToCSV(agreedPartnerDetails): void {
    const agreedPartnerDetailsList = agreedPartnerDetails.map(
      (element: {
        mpnId: any;
        partnerOneId: any;
        programName: any;
        country: any;
        email: any;
        createdDate: string | number | Date;
        financialYear: any;
      }): PartnerDetails => {
        return {
          PartnerId: element.mpnId,
          PartnerOneId: element.partnerOneId,
          ProgramName: element.programName,
          Country: element.country,
          Email: element.email,
          CreatedDate: this.datePipe.transform(
            element.createdDate,
            'MM/dd/yyyy'
          ),
          FinancialYear: element.financialYear
        };
      }
    );

    this.exportService.exportToCsv(
      agreedPartnerDetailsList,
      'AgreedPartnerDetails.csv'
    );

    this.loading = false;
  }

  get isButtonDisabled(): boolean {
    return (
      this.selectedProgramTypes == null ||
      this.agreementPartnerDetailsForm.controls['fromDate'].value == '' ||
      this.isEmptyPartnerList
    );
  }
}
